import React from "react";
import { makeStyles } from "@mui/styles";
import { Typography } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  footer: {
    display: "flex",
    
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(2),
    backgroundColor: "#ededed",
    maxWidth:"1000px",
    justifyContent:"flex-end",
    flexGrow:1,
    position:"relative"
    
  },
}));

export default function Footer() {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <Typography variant="body2" color="textSecondary">
        <a
          href="https://www.hitajitech.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          © Hitaji Technologies. All rights reserved.
        </a>
      </Typography>
      {/* <Typography variant="body2" color="textSecondary" style={{textAlign:"justify"}}>
        Hitaji Technologies harnesses the potential of knowledge through
        discovery and sharing of information. It provides answers to database
        queries by converting natural language into SQL code. SQLTranslate is
        powered by powerful language models and PostgreSQL technology.
        Currently, its accuracy is limited at 70%, but a highly-tuned version
        with 98% accuracy is soon to be launched. Hitaji is not responsible for
        the information displayed or generated. Please refrain from entering any
        personal information. All product and company names are protected by
        registered trademarks of their respective owners. Get in touch for a
        tailored solution for your company's internal data management needs.
      </Typography> */}
    </footer>
  );
}
